import React, { useRef } from "react";
import { useRecoilState } from "recoil";
import { Button, provincesPlain } from "@kido/ui";
import ReactToPrint from "react-to-print";
import {
  appThemeSelector,
  filtersSelector,
  reportIDSelector
} from "../../store/selectors";
import Disclaimer from "../Disclaimer";
import MainMetrics from "../MainMetrics";
import UniqueVisitorsNational from "../UniqueVisitorsNational";
import UniqueVisitorsInternational from "../UniqueVisitorsInternational";
import OvernightNational from "../OvernightNational";
import OvernightInternational from "../OvernightInternational";
import HoursNational from "../HoursNational";
import HoursInternational from "../HoursInternational";
import Billing from "../Billing";
import { ReactComponent as Logo } from "../../logo.svg";

const PDF = ({ generate, url, data }) => {
  const [theme] = useRecoilState(appThemeSelector);
  const [filters] = useRecoilState(filtersSelector);
  const [reportID] = useRecoilState(reportIDSelector);
  const componentRef = useRef();

  generate.current = false;

  console.log("data.uniqueVisitors.byLengthAll.nationalLengthAll");
  console.log(data.uniqueVisitors.byLengthAll.nationalLengthAll);

  console.log("data.uniqueVisitors.byLengthAll.internationalLengthAll");
  console.log(data.uniqueVisitors.byLengthAll.internationalLengthAll);

  const tourist = {
    current:
      data.uniqueVisitors.byLengthAll.nationalLengthAll.length &&
      data.uniqueVisitors.byLengthAll.internationalLengthAll.length
        ? {
            national: data.uniqueVisitors.byLengthAll.nationalLengthAll.filter(
              (d) => d.duration_bin === "overnight"
            )[0].uniques,
            international: data.uniqueVisitors.byLengthAll.internationalLengthAll.filter(
              (d) => d.duration_bin === "overnight"
            ).length
              ? data.uniqueVisitors.byLengthAll.internationalLengthAll.filter(
                  (d) => d.duration_bin === "overnight"
                )[0].uniques
              : 0
          }
        : {
            national: null,
            international: null
          },
    previous:
      data.uniqueVisitors.previousByLengthAll.previousNationalLengthAll
        .length &&
      data.uniqueVisitors.previousByLengthAll.previousInternationalLengthAll
        .length
        ? {
            national: data.uniqueVisitors.previousByLengthAll.previousNationalLengthAll.filter(
              (d) => d.duration_bin === "overnight"
            )[0].uniques,
            international: data.uniqueVisitors.previousByLengthAll.previousInternationalLengthAll.filter(
              (d) => d.duration_bin === "overnight"
            ).length
              ? data.uniqueVisitors.previousByLengthAll.previousInternationalLengthAll.filter(
                  (d) => d.duration_bin === "overnight"
                )[0].uniques
              : 0
          }
        : {
            national: null,
            international: null
          }
  };

  return (
    <div className="flex flex-col items-center justify-center mt-40">
      <div className="flex flex-col justify-center items-center">
        <Logo style={{ width: "150px", height: "150px" }} />
        <ReactToPrint
          trigger={() => (
            <Button mode={theme.mode} onClick={() => {}}>
              Descargar PDF
            </Button>
          )}
          content={() => componentRef.current}
        />
        <br />
        <Billing />
      </div>

      <div className="pdf w-full leading-snug avgStay" ref={componentRef}>
        <div className="no-display">
          <div className="page-header">
            <div className="p-3 text-xs text-white box-border font-bold">
              <strong>Smart Tourism</strong> report
            </div>
            <div className="p-3">
              <img className="h-4" src={`./${theme.theme.dark.logo}`} alt="" />
            </div>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <td>
                <div className="h-10"></div>
              </td>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                {/* Page 1 - MAIN METRICS */}
                <MainMetrics
                  filters={filters}
                  url={url}
                  data={data.mainMetrics}
                  tourist={tourist}
                />
                {/* <div className="no-display"> */}
                {/* Page 2 - Unique visitors NATIONALS*/}
                <UniqueVisitorsNational data={data.uniqueVisitors} />
                {/* Page 3 - Unique visitors INTERNATIONALS*/}
                <UniqueVisitorsInternational data={data.uniqueVisitors} />
                {/* Page 4 - Unique visitors OVERNIGHT NATIONALS*/}
                <OvernightNational data={data} />
                {/* Page 5 - Unique visitors OVERNIGHT INTERNATIONALS*/}
                <OvernightInternational data={data} />
                {/* Page 6 - Hours NATIONAlS*/}
                <HoursNational
                  data={data.uniqueVisitors}
                  ranks={data.ranks}
                  filters={filters}
                />
                {/* Page 7 - Hours INTERNATIONALS*/}
                <HoursInternational data={data.uniqueVisitors} />
                {/* Page 8 - DISCLAIMER*/}
                <Disclaimer />
                {/* </div> */}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PDF;
